var path = 'ui-formly/wrappers/tableCell/index.html';
var html = "<td>\r\n    <formly-transclude></formly-transclude>\r\n</td>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;